import React, { Suspense } from 'react';

import { Spinner, SpinnerProps } from './spinner/spinner';

interface Props {
    id?: string;
    spinner?: SpinnerProps;
    children: React.ReactNode;
    fallback?: React.ReactNode;
}

export const AsyncComponent = (props: Props) => {
    return (
        <Suspense fallback={props.fallback || <Spinner {...props.spinner} />}>{props.children}</Suspense>
    );
};

export default AsyncComponent;
